import * as Cookies from 'js-cookie'
import get from 'lodash-es/get'

import { configs } from '../../config/sites'
import { hasWindow } from './envHelper'

interface ICookiebotJob {
  job: () => any
  consent: Consent
}
const queue: ICookiebotJob[] = []

export enum Consent {
  statistics = 'statistics',
  marketing = 'marketing',
  necessary = 'necessary',
  preferences = 'preferences'
}

const execute = () => {
  while (queue.length) {
    const cookiebotJob = queue.pop()
    if (cookiebotJob) {
      const { job, consent } = cookiebotJob
      // what to do if Cookiebot fail to load or blocked?
      if (
        get(configs, 'defaults.features.turnOffCookiebot') ||
        consented(consent)
      ) {
        job()
      }
    }
  }
}

export const deferRun = (job: () => any, consent: Consent) => {
  if (hasWindow()) {
    queue.push({ job, consent })
    const hasConsentResponse =
      (window as any).Cookiebot && (window as any).Cookiebot.hasResponse

    if (
      get(configs, 'defaults.features.turnOffCookiebot') ||
      hasConsentResponse
    ) {
      execute()
    }
  }
}

if (hasWindow()) {
  window.addEventListener(
    'CookiebotOnAccept',
    e => {
      execute()
    },
    false
  )
}

export const consented = (consent: Consent) => {
  if (!hasWindow()) {
    return false
  }

  // Global cookiebot swither
  if (get(configs, 'defaults.features.turnOffCookiebot')) {
    return true
  }

  // when cookiebot is avaiable use it
  if (get(window, 'Cookiebot.consent')) {
    return !!get(window, `Cookiebot.consent.${consent}`)
  }

  // manually parse cookie if Cookiebot is not avaiable
  const CookieConsent = Cookies.get('CookieConsent')

  if (!CookieConsent) {
    return false
  }

  // For user outside of targeted area
  if (CookieConsent === '-1') {
    return true
  }

  try {
    const parsedCookieConsent = JSON.parse(
      CookieConsent.replace(/%2c/g, ',')
        .replace(/'/g, '"')
        // eslint-disable-next-line
        .replace(/([{\[,])\s*([a-zA-Z0-9_]+?):/g, '$1"$2":')
    )
    return parsedCookieConsent && !!parsedCookieConsent[consent]
  } catch (e) {
    return false
  }
}
